import {
  COMPANY_SWITCHER_MAX_PX,
  COMPANY_SWITCHER_WIDTH,
} from 'src/constants/uiConsts';
import { DesktopCompanySwitcher } from 'src/features/companies/CompanySwitcher';
import { ResizablePanel } from 'src/features/resizableWrapper/ResizablePanel';
import { ResizeHandle } from 'src/features/resizableWrapper/ResizeHandle';
import { useSidebarTheme } from 'src/legacy/components/Sidebar/useSidebarTheme';

export const COMPANY_SWITCHER_PANEL_ID = 'company-switcher-panel';

/**
 * The multi-company client's company column as a resizable panel, rendered
 * directly inside the shell's sidebar group ahead of the nav panel. Users can
 * widen it for long company names; the group persists the width like the nav.
 */
export const CompanySwitcherPanel = ({
  onResize,
}: {
  onResize: (sizeInPixels: number) => void;
}) => {
  const { sidebarTheme } = useSidebarTheme();

  return (
    <>
      <ResizablePanel
        id={COMPANY_SWITCHER_PANEL_ID}
        className="z-[1]"
        minSize={COMPANY_SWITCHER_WIDTH}
        defaultSize={COMPANY_SWITCHER_WIDTH}
        maxSize={COMPANY_SWITCHER_MAX_PX}
        groupResizeBehavior="preserve-pixel-size"
        onResize={onResize}
      >
        <div
          style={{ backgroundColor: sidebarTheme.sidebarBackgroundColor }}
          className="h-full box-border border-0 border-solid border-r border-r-[rgba(0,0,0,0.1)]"
        >
          <DesktopCompanySwitcher theme={sidebarTheme} />
        </div>
      </ResizablePanel>
      {/* The handle sits inside the branded sidebar, so it rests in the sidebar
          colour (the column's own border stays the visible divider) and hovers
          like every other element in the sidebar does. */}
      <ResizeHandle
        className="z-[1]"
        restColor={sidebarTheme.sidebarBackgroundColor}
        activeColor={sidebarTheme.sidebarItemHoverBackground}
      />
    </>
  );
};
